module.exports = __webpack_public_path__ + "media/application/images/process_steps/bookstack_04-1b15c5660fd14c7b6be99bea84a5277f.png";